import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ParticleField from "./ParticleField";
import MouseGlow from "./MouseGlow";
import Logo from "./Logo";
import { pageTransition } from "../lib/motion";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen relative flex items-center justify-center px-6 overflow-hidden bg-[#090909] grain">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a1622] via-[#090909] to-[#090909]" />
      <ParticleField density={45} />
      <MouseGlow />
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#4da6ff] rounded-full blur-[160px] opacity-[0.1] animate-glow" />
      <motion.div className="relative z-10 w-full max-w-md" variants={pageTransition} initial="initial" animate="animate">
        <Link to="/" className="flex items-center justify-center mb-10" data-testid="auth-logo">
          <Logo size={36} textClassName="text-lg" />
        </Link>
        <div className="glass rounded-3xl p-8 md:p-10">
          <h1 className="font-head text-[28px] font-semibold text-center tracking-tight">{title}</h1>
          <p className="text-zinc-500 text-sm text-center mt-2.5 mb-8 font-light">{subtitle}</p>
          {children}
        </div>
        {footer && <div className="text-center mt-7 text-sm text-zinc-500 font-light">{footer}</div>}
      </motion.div>
    </div>
  );
}
